import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { ReportTemplateTypeEnum } from '../enums/report-template-type.enum';

/**
 * Report template DTO for records
 */
@CaslSubject(AppSubjectEnum.REPORT_TEMPLATE)
export class ReportTemplateRecordDto extends BaseDto {
	name!: string;
	description?: string;
	path?: string;
	notes?: string;
	type!: ReportTemplateTypeEnum;
	body?: string;
	bodyHash?: string;
	bodyVersion?: number;
	compiledBody?: string;
	tags?: TagListDto[];
}
